<template>
	<div class="finance-summary">
		<span>
			{{ t('revenue_fact_plan') }}:
			{{ money(project?.RevenueReal) }}<span :style="{margin: '0 1px'}">/</span>{{ money(project?.RevenuePlanned) }}
			({{ money(project?.RevenuePercentage) }}%)
		</span>
		<span>
			{{ t('balance_fact_plan') }}:
			<span style="color: #499259">{{ money(project?.BalanceReal) }}</span><span :style="{margin: '0 1px'}">/</span>{{ money(project?.BalancePlanned) }}
		</span>
	</div>
</template>

<script setup lang="ts">
import { i18n } from "@/i18n";
import { ProjectContainer } from "@/models/interfaces/project/project-models";
import { intlLocale } from "@/utils/format";

defineProps<{
	project?: ProjectContainer | null,
}>()

const t = (key: string) => i18n.global.t(key);

// Формат чисел идентичен разделу финансов: по языку интерфейса, дробную часть до 4 знаков, нули не показываем
const money = (n: number | null | undefined) =>
	new Intl.NumberFormat(intlLocale(), {
		minimumFractionDigits: 0,
		maximumFractionDigits: 4,
	}).format(n || 0);
</script>

<style scoped lang="scss">
.finance-summary {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: flex-end;
	column-gap: 12px;
	min-width: 0;
	font-size: 14px;
	line-height: 18px;
	color: #4D4D4D;
}
</style>
